module.exports = __webpack_public_path__ + "img/introductionBgImg1.a4a8f53c.png";